import { useUnit } from 'effector-react'

import SortIcon from '@/assets/icons/icon-sort.svg'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.tsx'
import { getVaultMediasFx } from '@/models/vault/medias'
import {
  $mediaSort,
  $mediaSortField,
  type MediaSortField,
  setMediaSort,
  setMediaSortField,
} from '@/models/vault/medias/options.ts'
import { classNames } from '@/utils/helpers.ts'

const sortFieldToTitle: Record<MediaSortField, string> = {
  recent: 'Recent',
  'most-liked': 'Most Liked',
  'highest-tips': 'Highest Tips',
}

export const VaultFilterSection = () => {
  const mediaSort = useUnit($mediaSort)
  const mediaSortField = useUnit($mediaSortField)
  const isLoadingMedia = useUnit(getVaultMediasFx.pending)

  return (
    <div className="mb-2 flex items-center justify-between px-3">
      <p className="text-lg font-medium text-secondary-200">
        {sortFieldToTitle[mediaSortField]}
      </p>
      <div>
        <DropdownMenu>
          <DropdownMenuTrigger disabled={isLoadingMedia}>
            <div
              className={classNames('cursor-pointer p-1', {
                'cursor-not-allowed opacity-50': isLoadingMedia,
              })}
            >
              <SortIcon className="dark:stroke-white" />
            </div>
          </DropdownMenuTrigger>
          <DropdownMenuPortal>
            <DropdownMenuContent
              className="z-[100] max-h-[400px] w-64 overflow-y-auto p-2"
              align="start"
              forceMount
            >
              <DropdownMenuItem
                className={classNames({
                  'bg-primary-500': mediaSortField === 'recent',
                })}
                onClick={() => setMediaSortField('recent')}
              >
                Recent
              </DropdownMenuItem>
              <DropdownMenuItem
                className={classNames({
                  'bg-primary-500': mediaSortField === 'most-liked',
                })}
                onClick={() => setMediaSortField('most-liked')}
              >
                Most Liked
              </DropdownMenuItem>
              <DropdownMenuItem
                className={classNames({
                  'bg-primary-500': mediaSortField === 'highest-tips',
                })}
                onClick={() => setMediaSortField('highest-tips')}
              >
                Highest Tips
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                className={classNames({
                  'bg-primary-500': mediaSort === 'asc',
                })}
                onClick={() => setMediaSort('asc')}
              >
                Ascending
              </DropdownMenuItem>
              <DropdownMenuItem
                className={classNames({
                  'bg-primary-500': mediaSort === 'desc',
                })}
                onClick={() => setMediaSort('desc')}
              >
                Descending
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenuPortal>
        </DropdownMenu>
      </div>
    </div>
  )
}
